/**
 * Base style props for input fields
 * @property {("primary" | "danger" | "dark-grey")} [textColor] - Input text color
 * @property {("italic" | "normal")} [placeholderStyle] - Placeholder text style
 * @property {Object} [padding] - Input padding
 * @property {("none" | "sm" | "md" | "lg")} [padding.left] - Left padding
 * @property {("none" | "sm" | "md" | "lg")} [padding.right] - Right padding
 * @property {("white" | "transparent" | "gray-100")} [backgroundColor] - Background color
 * @property {string} [className] - Additional Tailwind classes
 */
export interface BaseInputStyleProps {
  textColor?: "primary" | "danger" | "dark-grey";
  placeholderStyle?: "italic" | "normal";
  padding?: {
    left?: "none" | "sm" | "md" | "lg";
    right?: "none" | "sm" | "md" | "lg";
  };
  backgroundColor?: "white" | "transparent" | "gray-100";
  className?: string;
}

export const defaultBaseInputStyles: BaseInputStyleProps = {
  textColor: "primary",
  placeholderStyle: "italic",
  padding: {
    left: "md",
    right: "lg",
  },
  backgroundColor: "white",
};

export const baseInputStylesMap = {
  padding: {
    none: "p-0",
    sm: "px-2",
    md: "px-4",
    lg: "px-6",
  },
} as const;
